import Component from '@glimmer/component';
import { service } from '@ember/service';
import { registerDestructor } from '@ember/destroyable';
import type CableService from 'tio-common/services/cable';
import type Owner from '@ember/owner';

type DocumentStateBroadcast = {
  transition?: { event?: string };
};

/**
 * While mounted, listens for content_reflected on the signed-in person’s document stream and calls onActivity.
 * The server infers the person without an ID parameter; intermediate extraction events are ignored.
 * Good-standing evaluation follows reflection asynchronously, so a reload may precede the new verdict;
 * later activity or a visit converges. Demo cable subscriptions are already no-ops.
 */
interface DocumentActivityListenerSignature {
  Args: {
    /** Fired on each reflection landed for the signed-in person. */
    onActivity: () => void;
  };
}

const CHANNEL_PARAMS = { channel: 'ObservableDocumentStatusChannel' };

export default class DocumentActivityListener extends Component<DocumentActivityListenerSignature> {
  @service declare cable: CableService;

  constructor(owner: Owner, args: DocumentActivityListenerSignature['Args']) {
    super(owner, args);

    this.cable.subscribe(CHANNEL_PARAMS, {
      received: (data: unknown) => {
        const message = data as DocumentStateBroadcast;
        if (message?.transition?.event === 'content_reflected') {
          this.args.onActivity();
        }
      },
    });

    registerDestructor(this, () => {
      this.cable.unsubscribe(CHANNEL_PARAMS);
    });
  }

  <template></template>
}
